import * as types from "./actionTypes";
import log from "../utils/log";

export const errorHide = () => {
  log.info("[ERROR ACTION] ERROR_HIDE");
  return {
    type: types.ERROR_HIDE
  };
};

export const errorShow = (message) => {
  log.info("[ERROR ACTION] ERROR_SHOW");
  return {
    type: types.ERROR_SHOW,
    message
  };
};



// WEBPACK FOOTER //
// ./src/actions/errorActions.js